//import './../../index.ts';

const Hr = ()=>{
	return(
		<hr/>
		);
}

export default Hr;